export function hideDefinitionBlock() {
	document
		.getElementById('definition-content-block')
		.classList.add('d-none');
}

export function showDefinitionBlock() {
	document
		.getElementById('definition-content-block')
		.classList.remove('d-none');
}


export function switchLanguageFromAddDefinition() {
	document
		.getElementById('structure-add-definition-container')
		.classList.add('d-none');

	document
		.getElementById('structure-headerDefinition')
		.classList.remove('d-none');

	document
		.getElementById('structure-definitionText')
		.classList.remove('d-none');
	document
		.getElementById('structure-sourceText')
		.classList.remove('d-none');
}
